import React from "react";
import { sanitizeInput } from "../utils/securityUtils";

const CustomInput = (props) => {
  const { type, label, i_id, i_class, name, val, onChng, onBlr } = props;
  
  // Sanitize the value before displaying, but preserve numeric values
  const sanitizedValue = val !== undefined && val !== null ? 
    (typeof val === 'number' ? val : sanitizeInput(val.toString())) : '';
  
  // Sanitize the onChange event
  const handleOnChange = (e) => {
    if (onChng) {
      let value = e.target.value;
      
      // For numeric inputs, preserve the numeric type
      if (type === 'number' && value !== '') {
        value = parseFloat(value);
      } else if (typeof value === 'string') {
        // Only sanitize string values
        value = sanitizeInput(value);
      }
      
      // Create a new event with sanitized/preserved value
      const sanitizedEvent = {
        ...e,
        target: {
          ...e.target,
          value: value
        }
      };
      onChng(sanitizedEvent);
    }
  };
  
  // Sanitize the onBlur event
  const handleOnBlur = (e) => {
    if (onBlr) {
      let value = e.target.value;
      
      // For numeric inputs, preserve the numeric type
      if (type === 'number' && value !== '') {
        value = parseFloat(value);
      } else if (typeof value === 'string') {
        // Only sanitize string values
        value = sanitizeInput(value);
      }
      
      // Create a new event with sanitized/preserved value
      const sanitizedEvent = {
        ...e,
        target: {
          ...e.target,
          value: value
        }
      };
      onBlr(sanitizedEvent);
    }
  };
  
  return (
    <div className="form-floating mt-3">
      <input
        type={type}
        className={`form-control ${i_class} rounded-lg border-gray-300 dark:border-gray-600 focus:border-primary-light dark:focus:border-primary-dark focus:ring-2 focus:ring-primary-light dark:focus:ring-primary-dark`}
        id={i_id}
        placeholder={label}
        name={name}
        value={sanitizedValue}
        onChange={handleOnChange}
        onBlur={handleOnBlur}
      />
      <label htmlFor={label} className="text-text-light dark:text-text-dark">{label}</label>
    </div>
  );
};

export default CustomInput;